import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c41dc1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "q-pa-sm ecran-container",
  style: {"font-family":"'Roboto', sans-serif"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-blue" }, "CEREREA DVS. A FOST TRIMISA CU SUCCES!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "app__color--semigray",
  style: {"padding-top":"2rem","padding-bottom":"2rem"}
}, " IN CEL MAI SCURT TIMP VOM REVENI CU CEA MAI BUNA OFERTA! ", -1))
const _hoisted_4 = { class: "app__label--large" }
const _hoisted_5 = {
  class: "app__label--medium",
  style: {"text-align":"center"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" PUTETI CONSULTA STADIUL SOLICITARILOR TRANSMISE IN CONTUL DVS. ACCESAND SECTIUNEA ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "app__color--gray",
  style: {"font-weight":"bold","font-size":"1.5rem"}
}, " VA MULTUMIM! ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.pidOffer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_icon, {
            name: "check",
            color: "blue",
            style: {"font-weight":"bold","font-size":"3rem"}
          }),
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", null, "ID CERERE " + _toDisplayString(_ctx.pidOffer), 1)
          ]),
          _createElementVNode("p", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_q_btn, {
              outline: "",
              icon: "shop",
              color: "blue-9",
              label: "Oferte si Comenzi",
              onClick: _ctx.onGoToOffers
            }, null, 8, ["onClick"])
          ]),
          _hoisted_7
        ]))
      : _createCommentVNode("", true)
  ]))
}